import { useEffect, useState } from 'react'
import { Result, Button } from 'antd'
import { SkeletonUpgradeSuccess } from '../features/skeleton'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { SPACING } from '../styles/theme'
import { useFeatureAccessContext } from '../context/featureAccess'
import { ProfileService } from '../services/profile/profileService'
import { analytics } from '../utils/analytics'

const PageContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: ${SPACING.xxl};
  min-height: 80dvh;
  display: flex;
  align-items: center;
  justify-content: center;
`

export function UpgradeSuccessPage() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const { refetch } = useFeatureAccessContext()

  useEffect(() => {
    // Give webhook time to process before refreshing feature access
    const timer = setTimeout(() => {
      void (async () => {
        // Mark onboarding as complete (in case user came from onboarding upgrade page)
        await ProfileService.markOnboardingComplete()
        // Refresh feature access to get updated tier and onboarding status
        await refetch()
        analytics.upgradeCompleted()
        setLoading(false)
      })()
    }, 2000)

    return () => clearTimeout(timer)
  }, [refetch])

  if (loading) {
    return <SkeletonUpgradeSuccess />
  }

  return (
    <PageContainer>
      <Result
        status="success"
        title="Welcome to Pro!"
        subTitle="Your subscription is now active. You can now access all Pro features. Thank you for upgrading!"
        extra={[
          <Button type="primary" key="dashboard" onClick={() => navigate('/')}>
            Go to Dashboard
          </Button>,
          <Button key="settings" onClick={() => navigate('/settings?section=billing')}>
            View Billing
          </Button>,
        ]}
      />
    </PageContainer>
  )
}
